export default "__VITE_ASSET__da033fb7__"